var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuotationTable',{key:_vm.display,attrs:{"opportunity":_vm.opportunity,"quotations":_vm.quotations,"loading":_vm.loading},on:{"reload":_vm.reload,"confirmDelete":_vm.deleteQuotation}})}
var staticRenderFns = []

export { render, staticRenderFns }